import React from 'react';
import styled from 'styled-components/macro';
import { Div } from '../../../../components/grid';
import { FaCity, FaEnvelope, FaHashtag, FaHome, FaPhoneAlt, FaRegUser, FaUser } from '../../../../components/Icons';

const IconContainer = styled(Div)`
  border: 2px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
  border-right: 0;
  display: block;
  position: relative;

  & > svg {
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const IconNoProps = ({
  phone,
  hashtag,
  user,
  userAlt,
  home,
  city,
  envelope,
}) => (
  <IconContainer>
    {phone && <FaPhoneAlt />}
    {hashtag && <FaHashtag />}
    {user && <FaUser />}
    {userAlt && <FaRegUser />}
    {home && <FaHome />}
    {city && <FaCity />}
    {envelope && <FaEnvelope />}
  </IconContainer>
);

export default styled(IconNoProps)`
  font-size: 18px;
  position: relative;
  top: 2px;
  width: 20px !important;
  text-align: center;
`;
